<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      <!--First Dialog body section -->
        <section>
            <el-dialog
                title=""
                :visible.sync="getdialogVisible"
                close="false"
                :close-on-click-modal="false"
                class="SID0009_DilaogDiv PrintHideArea"
                >
                <el-container>
                    <div class="SID1043__popupScreen">
                        <div class="firstSpan">
                            <span>ご利用中のユーザーは印刷を行うことができません。</span>
                        </div><br>
                        <div class="ButtonClose">
                            <el-button type="info" plain @click="closeTab">閉じる</el-button>
                        </div>
                    </div>
            </el-container>
            </el-dialog>
        </section>
      <div class="main-div" v-if="mc_pdf_print_flag_load" v-loading.fullscreen.lock="fullscreenLoading">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <!--SID1010 Body Part section-->
              <template>
                <el-container class="SID1024__SearchArticle">
                  <div class="SID1024__UserGroupList">
                    <el-form ref="form" :model="form" :rules="rule1" label-width="auto">
                      <el-row class="SID1040__Container__row">
                        <el-col>
                          <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '' }">複数部印刷</el-breadcrumb-item>
                            <!-- <el-breadcrumb-item>複数部印刷</el-breadcrumb-item> -->
                          </el-breadcrumb>
                        </el-col>
                      </el-row>
                      <el-row :gutter="15" class="filterRow">
                        <el-col>
                          <div class="divKeyword" prop="input1">キーワード</div>
                          <div class="grid-content">
                            
                            <el-form-item class prop="input1" >
                            <el-input v-model="form.input1" placeholder="キーワード" :disabled="articleMedia == 1"></el-input>
                          </el-form-item>
                          </div>
                        </el-col>
                        <el-col>
                          <div class="divMediumName" prop="input2">媒体名</div>
                          <div class="grid-content">
                            
                            <el-form-item class prop="input2" >
                            <el-input v-model="form.input2" class="el-input2" placeholder="媒体名" :disabled="articleMedia == 1"></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col>
                          <div class="themelabel">検索条件</div>
                          <div class="grid-content">
                            
                            <el-select class="select-margintop" v-model="form.ValueSelectSearch_1" @change="searchConditionChange($event)">
                              <el-option
                                v-for="item in getsearchcondition"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </div>
                        </el-col>
                        <el-col>
                          <div class="clippinglabel">クリッピング日</div>
                          <div class="grid-content">
                            <el-form class="ArticleSearchInner">
                              
                              <el-form-item label class="ArticleSearchInnerItem1">
                                <!-- Change by CK for backlog Id: 1440 for calendar input  only by clicking  -->
                                <v-date-picker
                                  class="select-margintop"
                                  mode="range"
                                  v-model="range"
                                  :masks="{ title: 'YYYY年MMM' }"
                                  :popover="{  visibility: 'click' }"
                                  :input-props='{readonly : true}'
                                  id="Date1024"
                                  locale="ja">
                                <input slot-scope="{ inputProps, inputEvents }"          
                                        v-bind="inputProps"
                                        v-on="inputEvents" />
                                </v-date-picker>
                              </el-form-item>
                            </el-form>
                          </div>
                        </el-col>
                        <el-col>
                           <div class="themelabel">テーマ</div>
                          <div class="grid-content">
                           
                            <el-select v-model="form.ValueSelectSearch_0" class="select-margintop" @change="themeChange($event)">
                              <el-option
                                v-for="item in gettheme"
                                :key="item.id"
                                :label="item.value"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </div>
                        </el-col>
                        <el-col class="buttonArea">
                          <div class="grid-content">
                            <el-button
                              type="primary"
                              class="button-underDivider2 select-margintop"
                              @click="CheckForSelectionInTable('form')" 
                              plain
                            >検索</el-button>
                          </div>
                        </el-col>
                      </el-row>
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          class="button-underDivider2 floatleft"
                          @click="PrintCopyPopupScreen"
                          plain
                        >印刷</el-button>
                      </div>
                    </el-form>
                    <section v-show="isShowing_table1">
                      <el-table v-loading="loading"
                            border
                            ref="multipleTable"
                            :data="getTableResult1043"
                            :span-method="arraySpanMethod"
                            style="width: 100%"
                            @selection-change="handleSelectionChange"
                            default-expand-all
                            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                            class="first_table">
                        <el-table-column
                          type="selection"
                          width="60"
                        ></el-table-column>
                        <el-table-column width="80" property="no" label="No">
                          <template slot-scope="scope">
                            <span class="commentIcon" v-if="scope.row.theme_name == 'Comment'"></span>
                            {{scope.row.no}}
                          </template>
                        </el-table-column>
                        <el-table-column min-width="350" property="article_title" label="見出し">
                          <template slot-scope="scope">
                            <!-- 2021/02/07 #10492 START -->
                            <!--  <el-link v-html="scope.row.article_title" @click="sendToErrorDisplayTitle(scope.row.article_id,scope.row.data_section,scope.row.no_image_flag)" class="comment_usr linkToNextPage" type="primary" :underline="false"></el-link> -->                            
                            <div v-if="scope.row.theme_name == 'Comment'">
                              <el-link
                                :underline="false"
                                type="primary"
                                v-html="scope.row.article_title"
                                class="UserComment"
                              ></el-link>
                            </div>
                            <div v-else>
                              <el-link
                                :underline="false"
                                type="primary"
                                v-html="scope.row.article_title"
                                @click="sendToErrorDisplayTitle(scope.row.article_id,scope.row.data_section,scope.row.no_image_flag)"
                                class="comment_usr linkToNextPage"
                              ></el-link>
                            </div>
                            <!-- 2021/02/07 #10492 END -->
                          </template>
                        </el-table-column>
                        <!-- 2023/09/22  #14935 START-->
                        <el-table-column min-width="170" label="媒体名">
                        <!-- 2023/09/22  #14935 END-->
                          <template slot-scope="scope">
                            <span style v-if="scope.row.data_section == 1">
                              {{ scope.row.media_name }}
                              <br />
                              <img
                                class="tableInside-img"
                                src="../../assets/image/logo-new.png"
                                alt="LOGO"
                              />
                            </span>
                          </template>
                        </el-table-column>
                        <!-- 2023/09/22  #14935 START-->
                        <!-- <el-table-column min-width="85" property="issue_date" label="年月日"></el-table-column>-->
                        <el-table-column width="120" property="issue_date" label="年月日"></el-table-column>
                        <!-- 2023/09/22  #14935 END-->
                        <el-table-column min-width="152" property="issue_type" label="その他書誌情報"></el-table-column>
                        <el-table-column  property="theme_name" label="テーマ名"></el-table-column>
                        <!-- 2023/09/22  #14935 START-->
                        <el-table-column  type="index" width="200" label>
                        <!-- 2023/09/22  #14935 END-->
                          <div class="article-right" slot-scope="scope" >
                            <ul v-if="scope.row.data_section == 1" class="Unorderlist_1043_icons">
                              <li v-if="mc_pdf_view_flag == false || scope.row.no_image_flag == true">
                                <div class="ico_pdf_Disable" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <el-tooltip placement="top-start" effect="dark">
                                  <!-- 2021/02/23 #10026 START-->
                                  <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                  <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                    <!-- 2021/02/23 #10026 END-->
                                    <el-carousel-item :setActiveItem="item" v-for="item in scope.row.image_info" :key="item">
                                      <div style="width: 100px; height: 150px">
                                        <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                      </div>
                                    </el-carousel-item>
                                  </el-carousel>
                                  <div class="custom-arrow"></div>
                                  <div @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                </el-tooltip>
                              </li>
                              <li>
                                <div @click="sendToCSVDisplay(scope.row.article_id,scope.row.data_section,scope.row.no)"  class="ico_csv-output_upSmall" tabindex="0"></div>
                              </li>
                              <li v-if="mc_text_view_flag == false || scope.row.no_text_flag == true">
                                <div class="ico_text_Disable" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <div class="ico_text_upSmall" @click="getPdfPrintScreen(scope.row.data_section,scope.row.article_id,scope.row.no)" tabindex="0"></div>
                              </li>
                              <li v-if="mc_pdf_print_flag == false || scope.row.no_image_flag == true">
                                <div class="ico_print_Disable" tabindex="0"></div>                                   
                              </li>
                              <li v-else>
                                <div class="ico_print_upSmall AllNewsico_print_upSmall" @click="pdfPrint(scope.row.article_id,scope.row.data_section)" tabindex="0"></div>
                              </li>
                            </ul>
                          </div>
                        </el-table-column>
                      </el-table>
                    </section>
                  </div>
                </el-container>
              </template>
              <!--SID1010 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element" v-if="mc_pdf_print_flag_load">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
    <el-dialog
      class="SID1024_DilaogDiv"
      :visible.sync="dialogTableVisible"
      close="false"
      :close-on-click-modal="false" >
      <el-container>
        <!-- 2021/08/02  #11641  START -->
        <div class="SID1024__DialogPopup" v-loading.fullscreen.lock="fullscreenLoading1">
        <!-- 2021/08/02  #11641  END -->
          <!-- Dialog top section -->
          <div class="dialogTop">
            <span>複数部印刷</span>
          </div>
          <div class="paragraph">
            <span class="span-padding">
              ！！下記の注意事項を必ずご確認のうえ印刷をお願いします！！
            </span>
            <span>
              以下の入力欄にある「部数」がそのまま課金されます。
            </span>
            <span>
              プリンタの印刷部数は以下入力欄と同じ部数をご入力ください。
            </span>
            <span>
              以下の「承認ボタン」押下後の部数の訂正はできません。
            </span>            
          </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="popup_Input_Unit">
              <el-form-item prop="unit">
                 <!-- **Change by SJ for backlog Id: 1650  -->
                <el-input  controls="false" size="small" class="input-width" v-model="ruleForm.unit"></el-input>
                <span class="span-width">部</span>
              </el-form-item>
              <el-form-item>
                <div class="button_DialogClose">
                  <el-button type="info" plain @click="dialogTableVisible = false">キャンセル</el-button>
                  <el-button type="primary" plain @click="successonsubmit('ruleForm')">部数と上記注意事項を承認</el-button>
                </div>
              </el-form-item>
            </el-form>
          <section></section>
          <!-- Dialog top sub section -->
          <!-- Dialog body content section -->
          <section>
            <el-form ref="form" :model="form"></el-form>
          </section>
          <section>
            <el-form ref="form" :model="form"></el-form>
          </section>
        </div>
      </el-container>
    </el-dialog>
  </div>
</template>
<script>
import error_image from "../../assets/image/errorThumbnail@3_200x200.png";
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import Vue from "vue";
import json from "../../components/config.json";
var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
// In your VueJS component.
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import router from '../../router';
export default {
  name: "app",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane
  },
  data() {
    var checkSpecialChar = (rule, value, callback) => {
			var passCheckLength= this.ruleForm.unit ;
			var passw=/[^0-9]+/i;
			if (passCheckLength.match(passw)) {
				callback(new Error('do not allow the special character'));
			} 
			else {
				callback();
			}
		};
    return {
      property: "",
      articleMedia: '0',
      loading : false,
      getdialogVisible : false,
      mc_pdf_print_flag_load : true,
      isShowing_table1: false,
      select_search_value: '',
      select_theme_value: '',
      select_theme_id: '',
      userId: '',
      contractId: '',
      theme_browsing: '',
      print_pdf_parameters : [],
      aid0012_input_info: [],
      // 2021/06/09  #11466  START
      collective_demand_max_count: "0",
      // 2021/06/09  #11466  END
      range: {
        start: new Date(CurrentYear, CurrentMonth, CurrentDay), // Jan 16th, 2018
        end: new Date(CurrentYear, CurrentMonth, CurrentDay) // Jan 19th, 2018
      },
      form: {
        dialog_input: "",
        input1: "",
        input2: "",
        input3: "",
        ValueSelectSearch_0: "テーマを選択",
        ValueSelectSearch_1: "検索条件から選択",
        value: "検索条件から選択",
        options: [
          {
            value: "検索条件から選択",
            input: "",
            label: "検索条件から選択"
          }
        ]
      },
      ruleForm: {
        unit: '1'
      },
      Errortext: "TR",
      rules: {
        unit: [
          {required: true,type: "string",message: "部数を入力してください。"},
          // **Change by SJ for backlog Id: 1650 **//
          {validator: checkSpecialChar,message: "部数は半角数字を入力してください。" },
          // **Change by SS for backlog Id: 1584 **//
          {required: true,pattern:/^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])?$/,message: "部数は1～999以外の値を入力できません。" }
          
        ]
      },
      rule1: {
        input1:[
          { max: 500, message: "キーワードは500文字以下を入力してください。" },
        ],
        input2:[
          { max: 100, message: "媒体名は100文字以下を入力してください。" }
        ]
      },
      dialogTableVisible: false,
      dummy: "",
      TableVisible: false,
      value1: true,
      value2: true,
      value3: true,
      value4: true,
      multipleSelection: [],
      contract_code:'',
      user_group_name:'',
      fullscreenLoading: false,
      // 2021/08/02  #11641  START
      fullscreenLoading1: false,
      // 2021/08/02  #11641  END
      session_id: ''
    }
  },

  computed: {
    ...mapGetters("situation1043", [
      "getTableResults1024",
      "getSelectSearch_0",
      "getSelectSearch_1",
      "getarticleCommentIndexArray",
      "getsearchcondition",
      "gettheme",
      "getTableResult1043"
    ]),
    ...mapGetters("situation0004", [
      "getPdfSuccessStatus"
    ]),
    ...mapGetters("situation0008", [
      "getStatus"
    ]),
    ...mapGetters("situation0001", [
        "getUserId",
        "getContractId",
        "getThemeBrowsing",
        "getContractCode",
        "getCompanyConfigurationInfo",
        "getMC_Pdf_View_Flag",
        "getMC_Pdf_Print_Flag",
        "getMC_Text_View_Flag",
        "getMC_Text_Print_Flag",
        "getSC_Pdf_View_Flag",
        "getSC_Pdf_Print_Flag",
        "getSC_Text_View_Flag",
        "getSC_Text_Print_Flag",
        "getServiceLinkageInfo",
        "getMessageInfo",
        "getUserGroupName",
        "getOut_Demand_Confirm_Message_Div_Flag",
        "getDemandConfirmPdfMessage",
        "getDemandConfirmTextMessage",
        "getDemandConfirmPrintMessage"

      ])
  },
  mounted() {
      this.mc_pdf_view_flag = this.getMC_Pdf_View_Flag
      this.mc_text_view_flag = this.getMC_Text_View_Flag
      this.mc_text_print_flag = this.getMC_Text_Print_Flag
      this.sc_pdf_view_flag = this.getSC_Pdf_View_Flag
      this.sc_pdf_print_flag = this.getSC_Pdf_Print_Flag
      this.sc_text_view_flag = this.getSC_Text_View_Flag
      this.sc_text_print_flag = this.getSC_Text_Print_Flag
      var message_info = this.getMessageInfo
      for(var u=0;u<message_info.length;u++)
      {
        if(message_info[u].message_key == "demandConfirmPdfMessage")
        {
          this.pdf_confirm_message_flag = message_info[u].configuration_value
        }
        else if(message_info[u].message_key == "demandConfirmTextMessage")
        {
          this.text_confirm_message_flag = message_info[u].configuration_value
        }
        else if(message_info[u].message_key == "demandConfirmPrintMessage")
        {
          this.print_confirm_message_flag = message_info[u].configuration_value
        }
        else
        {
          //no action needed
        }
      }
      //get the contract_id value from session
      this.contractId = this.getContractId

      //get the user id value from session
      this.userId = this.getUserId

      this.contract_code = this.getContractCode

      //get the theme_browsing value from session
      this.theme_browsing = this.getThemeBrowsing

      this.user_group_name = this.getUserGroupName

    // 2021/06/09  #11466  START
      //get the service linkage info value from the session
    var company_configuration_info = this.getCompanyConfigurationInfo;

    for(var s=0;s<company_configuration_info.length;s++)
    {
      if(company_configuration_info[s].configuration_key == "DELAY_MESSAGE_MAX")
      {
        this.collective_demand_max_count = company_configuration_info[s].configuration_value;
      }
    }
    // 2021/06/09  #11466  END

      var credentials = {
        contract_id:this.contractId,
        user_id:this.userId
      };

      //get the session id value from session
      this.session_id = Vue.prototype.$session.get('session-id');

      //Api call for get search dropdown data
      this.$store.dispatch('communication1043/getArticleSearch', credentials);
      this.ShowTable();

      var themeDetails = {
        contract_id:this.contractId,
        theme_browsing:this.theme_browsing,
        user_id:this.userId,
        display_id:"SID1043"
      };
      //Api call for get theme data
      this.$store.dispatch('communication1043/getTheme', themeDetails);
  },
  beforeUpdate(){
		this.mc_pdf_print_flag = this.getMC_Pdf_Print_Flag;
      if(this.mc_pdf_print_flag == true)
      {
        this.getdialogVisible = false;
        this.mc_pdf_print_flag_load = true;
      }
      else
      {
        this.getdialogVisible = true;
        this.mc_pdf_print_flag_load = false;
      }
  },
  methods: {
    replaceByDefault(event) {
      event.target.src = error_image;
    },
    closeTab(){
      router.push('/0002');
    },
    PrintCopyPopupScreen(){
      this.$LogButtonEvent("1043","Printing");
      this.$LogMethodIN("1043","PrintCopyScreen");
      var selection = this.multipleSelection;
      if(selection.length > 0){
        // 2021/06/09  #11466  START
        //this.dialogTableVisible = true;
        if(selection.length <= this.collective_demand_max_count)
        {
          this.dialogTableVisible = true;
        }
        else
        {
          this.$alert("記事は"+this.collective_demand_max_count+"件以内で選択してください。","確認", {
              confirmButtonText: 'OK',
          })
        }
        // 2021/06/09  #11466  END
      }
      else{
        this.$alert(json["1043_print_failure_message"], json["1043_print_failure_title"], {
          confirmButtonText: 'OK',
        })
      }
    this.$LogMethodOut("1043","PrintCopyScreen");
    },
    sendToErrorDisplayTitle(articleid,data_section,no_image_flag){
      
      if(data_section == 1 && no_image_flag != false){
        //console.log("fase")
        
      }
      else
      {
        var pdfValues = {
          pdf_flag: 1,
          article_info:[
            {
              article_id: articleid,
              data_section: data_section
            }
          ],
          user_id:this.userId,
          contract_code:this.contract_code,
          theme_browsing: this.theme_browsing,
          display_id:"SID1043",
          is_mail:false
        };

        var inputPDFCountData = {
          data_info:[{
            data_section: data_section,
            user_id:this.userId,
            request_div:1,
            article_id:articleid,
            session_id: this.session_id, 
            user_group_name:this.user_group_name
          }]
        };

        var printCombinedArray = [];

        printCombinedArray = [...printCombinedArray, pdfValues, inputPDFCountData];
        
        if(this.getOut_Demand_Confirm_Message_Div_Flag)
        {
          this.$confirm(this.getDemandConfirmPdfMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm"){
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                this.$session.set('pdfCombinedArray', printCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                /*this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })*/
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                done();
              }else{
                done();
              }
            }
          });
        }
        else
        {
          /*******BT08460_EXTERNAL-1539 issue fix*******/
          this.$session.set('pdfCombinedArray', printCombinedArray);
          let routeData = this.$router.resolve({name: '0001-001'}); 
          window.open(routeData.href, '_blank');
          /*this.fullscreenLoading = true;
          this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
            this.fullscreenLoading = false;
          })
          .catch(() => {
            this.fullscreenLoading = false;
          })*/
          /*******BT08460_EXTERNAL-1539 issue fix*******/
        }
      }

    },
    sendToErrorDisplay(articleid,data_section){
      this.$LogButtonEvent("1043","Showpdf");
      this.$LogMethodIN("1043","sendToErrorDisplay");
      var pdfValues = {
        pdf_flag: 1,
        article_info:[
          {
            article_id: articleid,
            data_section: data_section
          }
        ],
        user_id:this.userId,
        contract_code:this.contract_code,
        theme_browsing: this.theme_browsing,
        display_id:"SID1043",
        is_mail:false
      };
      
      var inputPDFCountData = {
        data_info:[{
          data_section: data_section,
          user_id:this.userId,
          request_div:1,
          article_id:articleid,
          session_id: this.session_id, 
          user_group_name:this.user_group_name
        }]
      };

      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, inputPDFCountData];
      
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPdfMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm"){
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                this.$session.set('pdfCombinedArray', printCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                /*this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })*/
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                done();
              }else{
                done();
              }
            }
          }
        );
      }
      else
      {
        /*******BT08460_EXTERNAL-1539 issue fix*******/
        this.$session.set('pdfCombinedArray', printCombinedArray);
        let routeData = this.$router.resolve({name: '0001-001'}); 
        window.open(routeData.href, '_blank');
        /*this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })*/
        /*******BT08460_EXTERNAL-1539 issue fix*******/
      }
      this.$LogMethodOut("1043","sendToErrorDisplay");
    },
    getPdfPrintScreen(data_section,articlieid,no){
      this.$LogButtonEvent("1043","Showpdfprintscreen");
      this.$LogMethodIN("1043","getPdfPrintScreen");
      
      this.$session.set('Article_Id', articlieid);
      this.$session.set('CurrentRowNo', no - 1);
      var articleDetails = {
        articleId: articlieid,
        data_section: data_section,        
        printOption: true,
        is_mail:false,
        display_id:"SID1043"

      };
      if(data_section == 1 || data_section == '1'){
        if(this.getOut_Demand_Confirm_Message_Div_Flag)
        {
          this.$confirm(this.getDemandConfirmTextMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm")
              {
                let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
                window.open(routeData.href, '_blank');
                done();
              }
              else
              {
                done();
              }
            }
          });
        }
        else
        {
          let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
          window.open(routeData.href, '_blank');
        }
      }
      else if(data_section == 2 || data_section == '2')
      {
        if(this.getOut_Demand_Confirm_Message_Div_Flag)
        {
          this.$confirm(this.getDemandConfirmTextMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm")
              {
                let routeData = this.$router.resolve({name: '0007'}); 
                window.open(routeData.href, '_blank');
                done();
              }
              else
              {
                done();
              }
            }
          });
        }
        else
        {
          let routeData = this.$router.resolve({name: '0007'}); 
          window.open(routeData.href, '_blank');
        }
      }
        this.$LogMethodOut("1043","getPdfPrintScreen");
    },   
    
    pdfPrint(articleid,datasection){
      this.$LogButtonEvent("1043","PrintPdf");
      this.$LogMethodIN("1043","pdfPrint");
      var pdfValues = {
        pdf_flag:2,
        article_info:[
          {
            article_id: articleid,
            data_section: datasection
          }
        ],
        user_id:this.userId,
        contract_code:this.contract_code,
        theme_browsing:this.theme_browsing,
        display_id:"SID1043"
      }

      var inputPDFCountData = {
        data_info:[{
          data_section: datasection,
          request_div:2,
          read_count: 1,
          user_id:this.userId,
          article_id:articleid,
          session_id: this.session_id, 
          user_group_name:this.user_group_name
        }]
      };
      var printCombinedArray = [];
      printCombinedArray = [...printCombinedArray, pdfValues, inputPDFCountData];
      
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPrintMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm")
              {
                this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })
                done();
              }
              else
              {
                done();
              }
            }
          }
        );
      }
      else
      {
        this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      this.$LogMethodOut("1043","pdfPrint");
    },
    //Forr the error message when not allowed to take print
    errorPrint(){
      this.$alert("ご利用中のユーザーは印刷を行うことができません。", "誤差", {
        confirmButtonText: 'OK',
      })
    },
    //Functions for getting value selected in theme dropdown
    themeChange($event){
      this.$LogButtonEvent("1043","SelectTheme");
      this.$LogMethodIN("1043","themeChange");
			for(var j=0; j<this.gettheme.length;j++){
					if($event == this.gettheme[j].value){
            this.select_theme_value = this.gettheme[j]["value"];
            this.select_theme_id = this.gettheme[j]["id"];
					}
      }
      this.$LogMethodOut("1043","themeChange");
    },
    //Functions for getting value selected in search dropdown
    searchConditionChange($event){
      this.$LogButtonEvent("1043","Searchcondition");
      this.$LogMethodIN("1043","searchConditionChange");
			for(var j=0; j<this.getsearchcondition.length;j++){
					if($event == this.getsearchcondition[j].value){
            this.select_search_value = this.getsearchcondition[j]["value"];
            this.articleMedia = 1;
					}
      }
      //if search dropdown is selected, clear and disable the keyword and media textbox
			if(this.select_search_value == '検索条件から選択'){
        this.articleMedia = 0;
        this.select_search_value = '';
			}else{
        this.form.input1 = '';
        this.form.input2 = '';
      }
      this.$LogMethodOut("1043","searchConditionChange");
    },
    //Method for merge the columns of comments for Articles
    arraySpanMethod({ rowIndex, columnIndex }) {
      // This will check the IndexArray of Comments to merge the columns of Comments
      if (this.getarticleCommentIndexArray.indexOf(rowIndex) > -1) {
        if (columnIndex === 1) {
          // no
          return [1, 2]; // This will take colspan = 2
        } else if (columnIndex === 2) {
          //HeaderText
          return [1, 7]; // This will take colspan = 5
        } else {
          return [0, 0];
        }
      }
    },
    successonsubmit(formName) {
      
      this.$LogButtonEvent("1043","ApproveNumber");
      this.$LogMethodIN("1043","successonsubmit");

      // 2021/06/26  #11584-11585  START
      var printCompletionArray = [];
      var article_details = [];
      // 2021/08/02  #11641  START
      this.fullscreenLoading1 = true;
      // 2021/08/02  #11641  END
      this.$refs[formName].validate(valid => {
          if (valid) {
      if (this.ruleForm.unit != "") 
      {
        this.dialogTableVisible = false;
        if(this.print_pdf_parameters.article_info.length != 0)
          {
            Vue.prototype.$session.set("unit", this.ruleForm.unit);

            var read_count = 1;
            if(this.ruleForm.unit != '')
            {
              read_count = parseInt(this.ruleForm.unit);
            }

            for(var i=0;i<this.print_pdf_parameters.article_info.length;i++)
            {
              article_details.push({
                article_id: this.print_pdf_parameters.article_info[i].article_id,
                data_section: this.print_pdf_parameters.article_info[i].data_section
              });
             printCompletionArray.push({
                contract_id: this.contractId, 
                data_section: this.print_pdf_parameters.article_info[i].data_section, 
                user_id: this.userId, 
                read_count: read_count, 
                request_div: 2, 
                article_id: this.print_pdf_parameters.article_info[i].article_id, 
                session_id: this.session_id, 
                user_group_name: this.user_group_name
              }); 
            }
            var pdfValues = {
              pdf_flag:2,
              article_info:article_details,
              user_id:this.userId,
              contract_code:this.contract_code,
              theme_browsing:this.theme_browsing,
              display_id:"SID1043"
            };
              
            var printSuccessValues = {
              data_info: printCompletionArray
            }

            var printCombinedArray = [];
            printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];
            console.log(pdfValues);
            console.log(printSuccessValues);
            this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => { 
              // 2021/08/02  #11641  START
              this.fullscreenLoading1 = false;
              // 2021/08/02  #11641  END
            });
          }
        else{
          // 2021/08/02  #11641  START
          this.fullscreenLoading1 = false;
          // 2021/08/02  #11641  END
          this.dialogTableVisible = false;
          this.$alert(json["1043_checkbox_not_check_message"], json["1043_checkbox_not_check_message_title"], {
              confirmButtonText: 'OK',
          })	
        }
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$notify({
              title: "Title",
              message: "Message",
              type: "success"
            });
          } else {
            return false;
          }
        });
          // 2021/08/02  #11641  START
          this.fullscreenLoading1 = false;
          // 2021/08/02  #11641  END
      }
          }else {
          return false;
        }
      });
      
      //this.$refs[formName].validate(valid => {
      //    if (valid) {
      //if (this.ruleForm.unit != "") 
      //{
      //  this.dialogTableVisible = false;
      //  var selection = this.multipleSelection;
      //  if(selection.length > 0)
      //  {
      //    Vue.prototype.$session.set("unit", this.ruleForm.unit);
      //    this.$store.dispatch('communication0004/getPdfPrint', this.print_pdf_parameters).then(() => {
            
              
      //      });

      //      var read_count = 1;
      //      if(this.ruleForm.unit != '')
      //      {
      //        read_count = parseInt(this.ruleForm.unit);
      //      }
      //      var pdf_print_completion_notice_input  = this.aid0012_input_info;
      //      for(var i=0;i<pdf_print_completion_notice_input.data_info.length;i++)
      //      {
      //        pdf_print_completion_notice_input.data_info[i].read_count = read_count;
      //        if(this.select_theme_id != '')
      //        {
      //          pdf_print_completion_notice_input.data_info[i].theme_id = this.select_theme_id;
      //        }
      //      }
      //      this.$store.dispatch('communication1043/AID0054_pdf_print_completion_notice',pdf_print_completion_notice_input);
      //  }
      //  else{
      //    this.dialogTableVisible = false;
      //    this.$alert(json["1043_checkbox_not_check_message"], json["1043_checkbox_not_check_message_title"], {
      //        confirmButtonText: 'OK',
      //    })	
      //  }
      //} else {
      //  this.$refs[formName].validate(valid => {
      //    if (valid) {
      //      this.$notify({
      //        title: "Title",
      //        message: "Message",
      //        type: "success"
      //      });
      //    } else {
      //      return false;
      //    }
      //  });
      //}
      //    }else {
      //    return false;
      //  }
      //});
      // 2021/06/26  #11584-11585  END
      this.$LogMethodOut("1043","successonsubmit");
    },
    //Method for push checkbox selected article into an array
    handleSelectionChange(val) {
      this.$LogButtonEvent("1043","SelectionChange");
      this.$LogMethodIN("1043","handleSelectionChange");
     var aid0012_input_param = {
       data_info :[],
     };
      var seclect_article = {
        pdf_flag : 2,
        article_info :[],
        user_id : this.userId,
        contract_code : this.contract_code,
        theme_browsing : this.theme_browsing,
        display_id : "SID1043",
        is_mail:false
      };
      for(var i=0;i<val.length;i++){
        var inner_article = {};
        var aid0012_set_artice = {};
        inner_article.article_id = val[i].article_id;
        inner_article.data_section = val[i].data_section;
        inner_article.article_id = val[i].article_id;
        aid0012_set_artice.contract_id = this.contractId;
        aid0012_set_artice.data_section = val[i].data_section;
        aid0012_set_artice.user_id = this.userId;
        aid0012_set_artice.request_div = 2;
        aid0012_set_artice.article_id = val[i].article_id;
        aid0012_set_artice.User_group_name = this.user_group_name;
        aid0012_set_artice.read_count = 1;
        aid0012_set_artice.theme_id = null;
        aid0012_set_artice.theme_group_id = null;
        aid0012_set_artice.topics_id = null;
        aid0012_input_param.data_info.push(aid0012_set_artice);
        seclect_article.article_info.push(inner_article);
      }
      this.multipleSelection = val;
      this.print_pdf_parameters = seclect_article;
      this.aid0012_input_info = aid0012_input_param;
      this.$LogMethodOut("1043","handleSelectionChange");
    },
    //Method for redirecting to SID0006 and SID0007 page
    sendToCSVDisplay(article_id,data_section,no){
      this.$LogButtonEvent("1043","CsvDisplay");
      this.$LogMethodIN("1043","sendToCSVDisplay");
      this.$session.set('Article_Id', article_id);
      this.$session.set('CurrentRowNo', no - 1);
      this.$session.set('CurrentSID', "1043");
      //if data_section value is 1, redirect to SID0006 page
      if(data_section == 1){
        let routeData = this.$router.resolve({name: '0006'}); 
        window.open(routeData.href, '_blank');
      }else if(data_section == 2){ //if data_section value is 2, redirect to SID0007 page
        let routeData = this.$router.resolve({name: '0007'}); 
        window.open(routeData.href, '_blank');
      }
      this.$LogMethodOut("1043","sendToCSVDisplay");
    },
    //Method for redirecting to SID0008 page
    sendToTextDisplay(index,rows){  
          this.$LogButtonEvent("1043","TextDisplay");
          this.$LogMethodIN("1043","sendToTextDisplay");       
          // if(rows[index].data_section == 1){
            var articleDetails = {
              articleId: rows[index].article_id,
              data_section: rows[index].data_section,
              printOption: true,
              is_mail:false,
              display_id:"SID1043"
            };
            let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
            window.open(routeData.href, '_blank');
 
          this.$LogMethodOut("1043","sendToTextDisplay");  
      },
      CheckForSelectionInTable(){
          this.$LogButtonEvent("1043","Search");
          this.$LogMethodIN("1043","CheckForSelectionInTable");
          var selection = this.multipleSelection;
          if(selection.length > 0 ){
            this.$confirm("選択された記事を外し、検索してもよろしいでしょうか？","確認",
              {
                showCancelButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "キャンセル",
                beforeClose: (action, instance, done) => {
                  if(action === "confirm")
                  {
                    this.multipleSelection="";
                    this.ShowTable();
                    done();
                  }
                  else
                  {
                    done();
                  }
                }
            });
          }else{
            this.ShowTable();
          }
          this.$LogMethodOut("1043","CheckForSelectionInTable"); 
      },
       ShowTable(){
          this.$LogButtonEvent("1043","Tableshowing");
          this.$LogMethodIN("1043","ShowTable");
          this.loading = true;
          this.isShowing_table1 = true
            var startDate = this.range.start;
            var sdate = new Date(startDate),
            smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
            sday = ("0" + sdate.getDate()).slice(-2);
            //convert the date format
            var startResult = [sdate.getFullYear(), smnth, sday].join("/");
            //get the end date from the selected date
            var endDate = this.range.end;
            var edate = new Date(endDate),
            emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
            eday = ("0" + edate.getDate()).slice(-2);
            //convert the date format
            var endResult = [edate.getFullYear(), emnth, eday].join("/");
            var searchDetails;
            if(this.select_search_value != '')
            {
              if(this.select_theme_value != '')
              {
                searchDetails = {
                  contract_id:this.contractId,
                  user_id:this.userId,
                  search_title:this.select_search_value,
                  process_date_from: startResult,
                  process_date_to: endResult,
                  display_id:'SID1043',
                  contract_kbn:1,
                  theme_id: this.select_theme_id,
                  theme_browsing: this.theme_browsing
                }
              }
              else
              {
                searchDetails = {
                  contract_id:this.contractId,
                  user_id:this.userId,
                  search_title:this.select_search_value,
                  process_date_from: startResult,
                  process_date_to: endResult,
                  display_id:'SID1043',
                  contract_kbn:1,
                  theme_browsing: this.theme_browsing
                }
              }
            }
            else if(this.form.input1 != '')
            {
              if(this.form.input2 != '')
              {
                if(this.select_theme_value != '')
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    key_word: this.form.input1,
                    media_name: this.form.input2,
                    process_date_from: startResult,
                    contract_kbn:1,
                    process_date_to: endResult,
                    display_id:'SID1043',
                    theme_id: this.select_theme_id,
                    theme_browsing: this.theme_browsing
                  }
                }
                else
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    key_word: this.form.input1,
                    media_name: this.form.input2,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1043',
                    contract_kbn:1,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
              else
              {
                if(this.select_theme_value != '')
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    key_word: this.form.input1,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1043',
                    contract_kbn:1,
                    theme_id: this.select_theme_id,
                    theme_browsing: this.theme_browsing
                  }
                }
                else
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    key_word: this.form.input1,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1043',
                    contract_kbn:1,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
            }
            else
            {
              if(this.form.input2 != '')
              {
                if(this.select_theme_value != '')
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    media_name: this.form.input2,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1043',
                    contract_kbn:1,
                    theme_id: this.select_theme_id,
                    theme_browsing: this.theme_browsing
                  }
                }
                else
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    media_name: this.form.input2,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1043',
                    contract_kbn:1,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
              else
              {
                if(this.select_theme_value != '')
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1043',  
                    contract_kbn:1,                
                    theme_id: this.select_theme_id,
                    theme_browsing: this.theme_browsing
                  }
                }
                else
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1043',
                    contract_kbn:1,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
            }
             //Api call for load the table data
            Vue.prototype.$session.set('InputParameterFor0006',searchDetails);
            Vue.prototype.$session.set('CurrentAID',"0071");
              this.$store.dispatch('communication1043/getTableData', searchDetails).then(() => {
                this.isShowing_table1= true;
                 this.loading = false;
              }) 
              this.$LogMethodOut("1043","ShowTable"); 
    },
    
    },
  
  beforeCreate(){
		//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
  },
  created(){
     //For the screen Title
     document.title = "複数部印刷";
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 @import "1043.css";
</style>